const selectorToElement = (selector: string | Element | (() => Element)): Element | null => {
  if (typeof selector === "string") {
    return document.querySelector(selector);
  } else if (selector instanceof Element) {
    return selector;
  } else if (typeof selector === "function") {
    return selector();
  }
  return null;
};
export const waitForElement = async (
  selector: string | Element | (() => Element),
  timeout = 5000,
  minDelay?: number,
): Promise<void> =>
  void (await new Promise<void>((resolve, reject) => {
    const startTime = Date.now();
    const element = selectorToElement(selector);

    const resolveWithDelay = (): void => {
      if (minDelay) {
        const elapsedTime = Date.now() - startTime;
        const remainingDelay = Math.max(0, minDelay - elapsedTime);

        if (remainingDelay > 0) {
          setTimeout(resolve, remainingDelay);
          return;
        }
      }
      resolve();
    };

    if (element) {
      resolveWithDelay();
      return;
    }

    const observer = new MutationObserver(() => {
      const el = selectorToElement(selector);

      if (el) {
        observer.disconnect();
        resolveWithDelay();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    // Timeout di sicurezza
    setTimeout(() => {
      observer.disconnect();
      reject(new Error("Element not found within timeout"));
    }, timeout);
  }));
